import { useState, useEffect } from "react"
import { InmateCounts } from "./types"
import { BASE_URL } from "../constants"
import { useIsGeorgetownSite } from "../hooks"


export const useInmateCounts = (): InmateCounts | null => {
  const isGeorgetownSite = useIsGeorgetownSite()
  const [counts, setCounts] = useState<InmateCounts | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (isGeorgetownSite) return
    setIsLoading(true)
    const fetchCounts = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/bookings/inmateCount`)
        if (response.ok) {
          try {
            const data = await response.json()
            setCounts(data)
          } catch (e) {
            setError('Error fetching counts')
          }
        } else {
          setError('Error fetching counts')
        }
      } catch (e) {
        setError('Error fetching counts')
      } finally {
        setIsLoading(false)
      }
    }
    fetchCounts()
  }, [isGeorgetownSite])

  if (isLoading) return null
  if (error) return { male: 0, female: 0, total: 0 } as InmateCounts
  return counts as InmateCounts
}